import React from 'react';

export const UmrLogo = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 164.93 87.56"
      {...props}
    >
      <title>UMR</title>
      <defs>
        <style>
          {
            '.d{fill:#64b74d;}.e{fill:#1c1c1c;}.f{fill:#606060;font-family:UHCSans-Bold, UHC Sans;font-size:5px;}'
          }
        </style>
      </defs>
      <g id="a" />
      <g id="b">
        <g id="c">
          <g>
            <path
              className="e"
              d="M155.26,52.47c-7.08-.22-13.25-1.9-17.05-8.1-2.73-4.46-5.19-9.09-7.79-13.64-.49-.86-.89-1.9-1.63-2.46-.79-.59-1.93-.7-2.92-1.02-.23,.82-.66,1.63-.67,2.46-.06,3.41-.05,6.83,.03,10.25,.06,2.72,1.87,5.3,5.41,5.57,0,1.14,.05,2.7,.05,2.7h-20.48v-2.74c2.86-.68,3.64-1.36,3.74-2.63,.35-4.73,.27-10.82,.3-15.57,.03-6,.06-12,0-18-.05-5.85-4.27-8.47-9.59-5.89-.85,.41-1.59,1.46-1.93,2.38-.42,1.14-.48,2.45-.48,3.69-.03,10-.04,20,0,30,0,2.62,.34,5.47,4.56,6.34,0,.86,.06,2.47,.06,2.47l-19.68,1.21,.05-2.95s1.36-.26,1.77-.39c1.05-.33,2.44-.7,2.44-1.52,0-9.66,.12-20.69,.11-30.36,0-.37-.23-.74-.58-1.77-.74,1.51-1.3,2.46-1.68,3.47-3.73,9.79-7.49,19.58-11.1,29.41-.64,1.73-1.67,2.62-3.27,2.27-.83-.18-1.75-1.27-2.09-2.15-3.86-10.01-7.61-20.07-11.4-30.11-.28-.75-.66-1.47-1.6-2.24-.17,.6-.48,1.2-.48,1.8-.04,10.25-.02,20.5-.08,30.75-.02,2.88,1.97,3.74,4.41,3.83v2.88l-14.87,2.05v-3.29c4.46-1.6,4.53-1.69,4.53-6.49,0-12.5,.02-25-.03-37.5-.02-3.79-2.96-5.63-6.21-4.04-1.91,.93-2.09,2.63-2.09,4.44,0,9.75,.15,19.5-.1,29.25-.09,3.44-.77,6.98-1.86,10.24-3.27,9.81-13.54,12.16-20.69,10.96-10.19-1.71-15.42-7.86-15.63-18.23-.2-9.66-.08-19.33-.12-29,0-1.25-.09-2.5-.2-3.74-.22-2.45-1.38-4.09-3.98-4.33-.6-.06-1.68-.3-1.68-.3,0,0-.02-2.25-.02-2.39,2.6,0,5.72,0,8.44,0,4.33,0,15.52,.05,15.52,.05V2.38s-1.66,.14-2.28,.24c-2.54,.42-3.59,1.96-3.6,4.33-.03,10.92-.1,21.83,.08,32.74,.04,2.26,.8,4.61,1.71,6.72,1.68,3.91,4.97,5.64,9.26,5.36,4.05-.26,6.73-2.21,7.75-6.55,.85-3.61,1.27-7.39,1.35-11.1,.19-8.66,.06-17.33,.06-26,0-3.97-.49-4.52-4.27-5.47-.39-.1-2.5-.23-2.5-.23l-.02-2.36s22.05-.01,31.72-.06c1.58,0,2.29,.54,2.89,2.04,3.16,7.88,6.47,15.69,9.74,23.52,.37,.88,.85,1.71,1.66,3.32,.88-1.73,1.5-2.73,1.92-3.81,2.99-7.67,6-15.34,8.87-23.06C89.62,.48,90.4,0,91.96,0c13.67,.05,27.33,0,41,.07,2.15,.01,4.32,.32,6.43,.73,4.66,.91,7.94,3.61,8.99,8.29,1.16,5.15-.37,9.55-4.71,12.8-1.41,1.05-3.75,1.9-4.01,3.18-.29,1.45,1.17,3.33,2.05,4.93,2.18,3.92,4.26,7.93,6.8,11.61,1.36,1.98,4.74,4.14,6.77,5.49,0,1.54-.02,4.97-.02,5.36ZM125.18,13.4h-.01c0,2.57,.07,5.15-.03,7.72-.05,1.46,.36,2.1,1.94,2.09,4.33,0,7.83-1.97,9.32-5.78,1.61-4.13,1.39-8.18-1.62-11.69-1.79-2.09-4.16-2.86-6.93-2.65-1.86,.14-2.7,1-2.68,2.83,.03,2.49,0,4.98,0,7.47Z"
            />
            <text
              className="f"
              transform="translate(156.67 51.33) scale(.93 1)"
            >
              <tspan x={0} y={0}>
                SM
              </tspan>
            </text>
            <path
              className="d"
              d="M4.72,70.3L0,82.65s150.93-48.86,160.56,4.9c0,0,25.97-33.78-48.68-31.42-12.89,.41-46.13,1.82-107.16,14.17Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
